import React, { useState } from "react";
import "./SavedTabsPanel.css";

const SavedTabsPanel = ({ tabName, tabKey, handleTabClicked, selectedTab}) => {
  const [clicked, setClicked] = useState(false);
  return (
    <div
      onClick={() => {
        handleTabClicked(tabKey)
      }}
      className={`box flex justify-start items-center ${
        selectedTab === tabKey
          ? "text-[#4F4830] bg-[#EFC634]"
          : "text-[#4F4830] bg-white"
      }`}
    >
      {tabName}
    </div>
  );
};

export default SavedTabsPanel;
